module.exports = __webpack_public_path__ + "img/Interpretacao_de_Exames_Laboratoriais.36a6ec3f.jpg";